import React from "react";
import "../../styles/components/tableActionButton.css"

/**
 * Erstellt ein Icon fester Größe, welchem ein Kindelement mitgegeben werden kann,
 * welches eine Aktion beim Anklicken ausführt: bspw.: <Link>
 * @param id
 * @param iconName
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
function EATableActionButton({id, iconName, children}) {
    return (<div className={"tableActionButton icon " + iconName}>{children}</div>)
}

export default EATableActionButton;
